<template>
  <div class="card card-inactive mb-4 p-2 sm:p-4 min-w-0">
    <div class="flex justify-between min-w-0">
      <h3 class="text-base sm:text-lg break-words">{{ $t('KssFormComponent.kssTracker', { text: featureName }) }}: {{ archivedTask?.name }}</h3>
    </div>
    <div class="flex flex-row flex-wrap justify-start items-center min-h-9 my-1 gap-1" v-if="usersCount > 0">
      <font-awesome-icon icon="fa-users" class="shrink-0"/>
      <span class="font-normal break-words">{{ participantsCount + ' ' + $t('KssTaskCreatedComponent.participants', participantsCount) }} |</span>
      <span class="font-normal" :style="available">{{ participantsPercent }}</span>
    </div>
    <div class="flex flex-wrap justify-start gap-2">
      <div class="flex flex-row my-0.5 mx-0 py-1 px-2.5 items-center min-h-0 w-min rounded
            bg-[var(--color-inactive-dark)] text-white text-xs sm:text-sm">
        <font-awesome-icon icon="fa-calendar" class="shrink-0 w-4 sm:w-5 py-0.5 px-0.5"/>
        <p class="py-0.5 px-1">{{ formattedDate }}</p>
      </div>
      <div v-if="archivedTask?.outlook_id">
        <div class="flex flex-row my-0.5 mx-0 py-1 px-2.5 items-center min-h-0 w-min rounded
            bg-[var(--color-inactive-dark)]">
          <p class="text-white py-0.5 px-1 text-xs sm:text-sm">Outlook</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'KssTaskArchivedComponent',
  props: ['archivedTask'],
  data() {
    return {
      usersCount: this.archivedTask?.involvedUsers?.length || 0,
      minCount: this.$store.getters.getMinCount,
    };
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'kssTracker',
        this.$t('FallbackTexts.collaborationTracker'),
        this.$i18n?.locale,
      );
    },
    formattedDate() {
      const date = new Date(this.archivedTask.date_created);
      return `${(`0${date.getDate()}`).slice(-2)}.${(`0${date.getMonth() + 1}`).slice(-2)}.${date.getFullYear()}`;
    },
    participantsCount() {
      return this.archivedTask.involvedUsers.length;
    },
    participantsPercent() {
      if (this.usersCount >= this.minCount) {
        const percent = `${Number(this.archivedTask.percent).toFixed(2)}% ${this.$t('KssTaskCreatedComponent.completed')}`;
        return percent;
      }
      return this.$t('KssTaskArchivedComponent.lessParticipants', { count: this.minCount });
    },
    available() {
      if (this.usersCount >= this.minCount) {
        return 'color: var(--color-orange)';
      }
      return 'color: var(--color-disabled)';
    },
  },
};
</script>
